import * as React from "react"

import { useCustomerCompanyList } from "@boundless/bl-api-client/customer/services"
import { useStore } from "zustand"

import { GenericErrorComponent } from "@/components/error/GenericErrorComponent"
import { PendingComponent } from "@/components/error/PendingComponent"
import { companyListQueryOptions } from "@/lib/companies"
import { store } from "@/lib/store"

function Wrapper({ children }: { children: React.ReactNode }) {
  const { isPending, error } = useCustomerCompanyList(
    {},
    companyListQueryOptions(),
  )

  if (error) {
    return GenericErrorComponent({ error })
  }

  return <>{isPending ? <PendingComponent /> : children}</>
}

/**
 * @summary Initialize the Company list and selection.
 *
 * @desc This is used to fetch the initial company selection and store it in
 * the global state.
 *
 * It's necessary specially on page reloads, when the global state is empty and
 * it's not yet possible to use the `activeCompanyUuid` in the router's
 * `loader`/`beforeLoad` functions.
 */
export function CompanyWrapper({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useStore(store, (state) => state.isAuthenticated)
  const userRole = useStore(store, (state) => state.userRole)

  const isPartnerOrCustomer = ["partner", "customer"].includes(userRole || "")

  if (!isAuthenticated || !isPartnerOrCustomer) {
    return children
  }

  return <Wrapper>{children}</Wrapper>
}
